import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ContentProvider } from '@awp/content';
import { Observable, EMPTY } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { isNullOrEmpty, getRouteSegment, getParentRouteWithDataProperty, extractValueFromParams } from '@awp/core/utils';

@Injectable({
  providedIn: 'root'
})
export class ContentErrorPageResolver implements Resolve<any> {

  constructor(private contentProvider: ContentProvider) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const pageId = route.paramMap.get('pageId');
    const themeId = extractValueFromParams(route, 'themeId');
    const purchaseSegment = getRouteSegment(getParentRouteWithDataProperty(route, 'isPurchasePath'));

    return this.contentProvider.fetchRoot()
      .pipe(
        filter(p => p != null && p._embedded != null && p._embedded.errorPages != null),
        map(p => p._embedded.errorPages.errors),
        map(errorPages => {
          const errorPage = errorPages.find(i => i.url === pageId
                && (
                    (isNullOrEmpty(themeId) && isNullOrEmpty(i.parentUrl))
                  || (i.parentUrl === ':themeId' && !isNullOrEmpty(themeId) && purchaseSegment == null)
                  || (i.parentUrl === `:themeId\\${purchaseSegment}`)
                )
            );

          return errorPage != null && errorPage._link != null && errorPage._link.self != null
            ? errorPage._link.self.href
            : null;
        }),
        mergeMap(url => isNullOrEmpty(url) ? EMPTY : this.contentProvider.fetchContent(url))
      );
  }
}
